// global
import React from 'react';
import { PropTypes } from 'prop-types';
import { Modal, Segment } from 'semantic-ui-react';
// local
import DefaultButton from '../button/DefaultButton';
// styles
import styles from './DialogBox.module.scss';
// consts
import { COLORS } from 'app/config/colors';

function DialogBox(props) {
  const { options, children } = props;

  const {
    isOpen,
    title,
    description,
    confirmationTerm,
    onClose,
    onSubmit,
    size = 'tiny',
    showCancelButton = true,
    loading,
    image
  } = options;

  return (
    <Modal size={size} open={isOpen} className={styles.modal}>
      <Modal.Header className={styles.header}>{title}</Modal.Header>
      <Segment vertical loading={loading}>
        <Modal.Content className={styles.content}>
          {image ? (
            <div className={styles.imageContainer}>
              <img src={image} alt='' />
            </div>
          ) : null}
          <p>{description}</p>
          {children}
        </Modal.Content>

        <Modal.Actions className={styles.actions}>
          {showCancelButton && (
            <DefaultButton
              tag='Cancelar'
              onClick={onClose}
              backgroundColor={COLORS.WHITE_VARIANT}
              borderColor={COLORS.SECONDARY_VARIANT}
              color={COLORS.PRIMARY_VARIANT}
              colorHover={COLORS.PRIMARY_VARIANT}
              borderColorHover={COLORS.SECONDARY_VARIANT}
            />
          )}

          <DefaultButton
            tag={confirmationTerm || 'CONFIRMAR'}
            onClick={onSubmit}
            backgroundColor={COLORS.ACCENTUATED_VARIANT}
            borderColor={COLORS.ACCENTUATED_VARIANT}
            color={COLORS.WHITE_VARIANT}
            colorHover={COLORS.WHITE_VARIANT}
            backgroundColorHover={COLORS.ACCENTUATED_VARIANT}
            borderColorHover={COLORS.ACCENTUATED_VARIANT}
          />
        </Modal.Actions>
      </Segment>
    </Modal>
  );
}

DialogBox.defaultProps = {
  isSubmitButtonDisabled: false
};

DialogBox.propTypes = {
  options: PropTypes.object,
  isOpen: PropTypes.bool,
  size: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.string,
  description: PropTypes.oneOf([PropTypes.string, PropTypes.node]),
  confirmationTerm: PropTypes.string,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  isSubmitButtonDisabled: PropTypes.bool,
  children: PropTypes.node
};

export default DialogBox;
